module.exports = __webpack_public_path__ + "img/CRRM.a115fc57.svg";